<!-- <p>### md-page works!</p> -->

@if(mdx$){
<div [innerHTML]="[(mdx$ | async)?.text??'' | markdown]" class="inner"></div>
}